import MeetingEncrypted from './MeetingEncrypted';

export default MeetingEncrypted;
